// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__5HQ-j","footer__links":"Footer_footer__links__7R-ng","footer__icons":"Footer_footer__icons__qYhP6"};